import React, { useState } from "react";
import { Button, DialogActions, DialogContentText, IconButton, InputAdornment, TextField } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';

import { FieldValidationError, ValidationHelper } from "../../services/server/ServerResponses";
import { ShareService } from "../../services/ShareService";
import { useSharingDialog } from "./SharingDialog";
import { AssetShareType } from "../../entities/ShareItem";

const facebookRegex = /^(https?:\/\/)?(www\.)?facebook.com\/[a-zA-Z0-9(.?)?]/i;

interface Props {
    onClose: () => void;
}

export function RenderFacebook(props:Props){
    const sharingContext = useSharingDialog();
    const { sharedItem } = sharingContext;
    const [videoPath, setVideoPath] = useState("");
    const [goodParse, setGoodParse] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [errors, setErrors] = useState<FieldValidationError[]>([])

    const saveFacebook = async(e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (disabled)
            return;

        let url = tryParseUrlFacebook();

        if (url === null)
            return;

            
        setDisabled(true);
        const response = await ShareService.saveAssetShare({
            commentsEnabled: sharedItem.commentsEnabled,
            enabled: sharedItem.enabled,
            assetShareId: sharedItem.id,
            assetShareVideoTypeId: AssetShareType.Facebook,
            videoPath: `facebook://${url}`
        });
        setDisabled(false);

        if(response.error) return sharingContext.onError('An unknown error occurred. Please try again.');

        sharingContext.updateSharedItem(response.data);
        sharingContext.showMessage("Video saved")
    }

    const tryParseUrlFacebook = () =>  {
        setErrors([])
        const parsedUrl = videoPath.match(facebookRegex);

        if(!parsedUrl || parsedUrl.length === 0){
            setErrors([{ field: "Url", errors: ['Sorry, this Facebook url is invalid. (Example: https://www.facebook.com/watch/?v=10153231379946729)'] }]);
            setGoodParse(false)
            return null
        }

        const url = parsedUrl[1];
        setGoodParse(true);
        return url;
    }
    
    const handleClear = () => {
        setGoodParse(false);
        setVideoPath("");
    }

    return (
        <form onSubmit={(e) => saveFacebook(e)}>
            <DialogContentText style={{ paddingLeft: 0 }}>
                Add a link to your Facebook video.
                </DialogContentText>
            <TextField
                type="text"
                disabled={goodParse}
                label="Facebook URL"
                value={videoPath}
                margin="dense"
                fullWidth
                required
                onChange={e => setVideoPath(e.target.value )}
                helperText={<span dangerouslySetInnerHTML={{ __html: ValidationHelper.getFieldErrorSummary(errors, 'Url') }} />}
                error={ValidationHelper.isFieldInError(errors, 'Url')}
                InputProps={{
                    endAdornment:
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="remove url"
                                onClick={() => handleClear()}
                                style={{ display: goodParse ? "block" : "none" }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </InputAdornment>
                }}
            />
            <DialogActions>
                <Button color="primary" onClick={props.onClose}>
                    Cancel
                    </Button>
                <Button disabled={disabled || videoPath.length === 0} color="primary" type="submit">
                    Add Video
                </Button>
            </DialogActions>
        </form>
    );
}